import {
  ErrorPage,
  FilteredCreditApplication,
  Loader,
  useGetAvailableCredit,
  useMerchantById,
  useMerchantFinancingConfig,
} from '@applyonline/shared'
import { EFinancingProgram, EWorksheetStatus } from '@if/core/types'
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import { DEFAULT_STEP, EWorksheetStep, EWorksheetStepList } from './hooks'
import { canAccessWorksheet, getWorksheet } from './selectors'
import WorksheetStepper from './WorksheetStepper'

interface Props {
  creditApp: FilteredCreditApplication
}

const WorksheetPage = ({ creditApp }: Props) => {
  const { step } = useParams<{ step: EWorksheetStep }>()
  const navigate = useNavigate()
  const [merchant, isLoadingMerchant] = useMerchantById(creditApp.merchantId, creditApp.financingProgramId)

  const worksheet = getWorksheet(creditApp)

    const [financingProgramConfig, isFetchingConfig] = useMerchantFinancingConfig(
      creditApp.merchantId,
      EFinancingProgram.Personal,
    )
  const [availableCredit, isLoadingAvailableCredit] = useGetAvailableCredit(
    creditApp.id,
    creditApp.financingProgramId,
    true,
  )

  if (!step || !EWorksheetStepList.includes(step)) return <Navigate to={`../worksheet/${DEFAULT_STEP}`} replace />
  if (isLoadingMerchant || isLoadingAvailableCredit) return <Loader />
  if (!merchant) return <ErrorPage />
  if (!canAccessWorksheet(creditApp, merchant)) {
    if (creditApp.worksheet?.status !== EWorksheetStatus.Draft)
      return <Navigate to={`/creditapplication/${creditApp.id}/contract`} replace />
    return <Navigate to=".." replace />
  }

  return isFetchingConfig || isLoadingAvailableCredit ? (
    <Loader description="" />
  ) : (
    <WorksheetStepper
      merchant={merchant}
      creditApp={creditApp}
      setStep={(s) => navigate(`../worksheet/${s}`, { replace: true })}
      step={step}
      financingProgramConfig={financingProgramConfig!}
      worksheet={worksheet}
      availableCredit={availableCredit!}
    />
  )
}

export default WorksheetPage
